import { Outlet } from 'react-router-dom';
import { PublicHeader } from '@/components/layout/PublicHeader';
import { MAIN_CONTENT_ID } from '@/lib/constants/layout';

/**
 * Layout for the public Shared Startup Profile verification screens (MYN-58:
 * link-expired, email-verify, otp-verify). Uses the minimal `PublicHeader`
 * variant (marketing nav links only, no Home/Sign In/Get Started) over the
 * light page background, matching the design - an external recipient has no
 * account to sign into, so the marketing CTAs would be dead ends. The
 * read-only view itself (`/p/:token/view`) is separately chrome-light and
 * stays outside this layout.
 */
export function SharedProfileLayout() {
  return (
    <div className="flex min-h-screen flex-col bg-page-bg">
      <PublicHeader variant="minimal" />
      {/* Same contract as `AppLayout`: publish this layout's chrome height so
        a full-screen state below centers in the remaining viewport. The
        link-expired notice renders both here and, from `/p/:token/view`, with
        no layout at all - it reads whichever offset it inherits. */}
      <main
        className="flex-1 [--app-chrome-offset:var(--spacing-public-header)]"
        id={MAIN_CONTENT_ID}
      >
        <Outlet />
      </main>
    </div>
  );
}
